import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const slide = trigger('slide', [
  state('void', style({ opacity: 0, bottom: -5 })),
  state('enter', style({ opacity: 1, bottom: 0 })),
  transition('* <=> *', animate('200ms')),
]);
